'use client'
/***
 *
 * @file components/RichTextBox/index.tsx
 * @description RichTextBox component will be used for rendering the content.
 * @author Naveen Kumar
 * @organization Ingka Centres
 * @since 13 Feb 2024
 *
 */

import React, { useState } from "react";
// import "./RichTextBox.scss";
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import classNames from "classnames";
// import { useContentfulInspectorMode, useContentfulLiveUpdates } from "@contentful/live-preview/react";
import Loading from "@/shared/loading";

/** type of props to be passed in RichTextBox function component */
type T_Props = {
  /** id of RichText content type */
  id?: string,

  /** content of RichText content type */
  data?: any,

  /** content type of Richtext content */
  typeid?: string,

  textContent?: string
}

/**
 * Name: RichTextBox
 * 
 * Description: a functional component that takes in richtext content from Contentful and renders it on UI by parsing the richtext JSON response
 *
 * @param param0 object containing data, typeid and other props
 * @example T_Props
 * ```
 * type T_Props = {
 *    id?: string,      // optional
 *    data?: any,       // optional
 *    typeid?: string   // optional
 * }
 * ```
 * @returns an html element containing the richtext content delivered by Contentful
 */
const RichTextBox = ({ id = "reich-text", data, typeid, ...props }: T_Props) => {
  const elData = data?.content || data; //useContentfulLiveUpdates(data?.content || data);
  // const inspectorModeProps = useContentfulInspectorMode();

  return (
    <div 
      // {...inspectorModeProps({ fieldId: data?.contentType || 'baseplateRichtext', entryId: data?.sys?.id })} 
      id={data?.content?.id || id} className={classNames(`RichTextBox-container`, data?.title || '', data?.internalName || '', data?.content?.cssClass || "")} data-testid="RichTextBox">
      {/* <pre>{JSON.stringify(data, null, 2)}</pre> */}
      {(elData || props?.textContent) ? (
        (elData?.richText?.content || props?.textContent) ? (
          // documentToReactComponents(data)
          documentToReactComponents(elData?.richText || props?.textContent)
        ) : (
          documentToReactComponents(elData)
        )
      ) : (<Loading />)}
    </div>
  );
};

export default RichTextBox;
